import React from 'react'
import { CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';

import CardMedia from '@mui/material/CardMedia';


const GroupForm = ({CartCount,SelectedType,Groups,ShowDetails,LanguageID,RestInformation}) => {

  
  return (
    <div style={{
      height: (CartCount > 0 || SelectedType === 'Details' || SelectedType === 'Done') ? '62.5vh' : '73vh',           // Set height to allow space
      overflowY: 'auto',        // Enable vertical scroll
      padding: '10px',
    }}>
    <div className='row' style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
           
      }}>
        {Groups.map((item) => (
          <Card sx={{ minWidth: 350,maxWidth:350, margin: '8px' ,borderRadius:'20px',
            backgroundColor: (item.availble ==0 || RestInformation.availble==0)? 'lightgrey' : 'white',
            opacity: (item.availble ==0 || RestInformation.availble==0)? 0.5 : 1,
            pointerEvents: (item.availble ==0 || RestInformation.availble==0)? 'none' : 'auto'


          }}
          onClick={() => ShowDetails('Item',item.gid,item)}
          
                              >
            <CardActionArea>
              <CardMedia
                component="img"
                height="140"
                image={item.imageUrl}
                alt="No image"
                style={{ objectFit: 'fill' }}
                
              />
              {(LanguageID==1 ) && (
              <label
                style={{
                  fontFamily: 'basheer',
                  fontSize: '20px',
                  position: 'absolute',
                  bottom: '15px',
                  right: '10px',
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  padding: '5px',
                  borderRadius: '5px'
                }}
              >
                {item.groupName}
              </label>
             )}
              {(LanguageID==2 ) && (
              <label
                style={{
                  fontFamily: 'basheer',
                  fontSize: '12pt',
                  position: 'absolute',
                  bottom: '5px',
                  right: '5px',
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  padding: '5px',
                  borderRadius: '5px'
                }}
              >
                {item.groupNameEnglish}
              </label>
             )}
              {(LanguageID==3 ) && (
              <label
                style={{
                  fontFamily: 'basheer',
                  fontSize: '12pt',
                  position: 'absolute',
                  bottom: '5px',
                  left: '5px',
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  padding: '5px',
                  borderRadius: '5px'
                }}
              >
                {item.groupNameKurdish}
              </label>
             )}
            </CardActionArea>
          </Card>
        ))}
      </div>
      </div>
  )
}


export default GroupForm